import { action, observable } from 'mobx'
import { REPORT_TYPE } from '../constants'
import { ReportRequest } from '../requests/ReportRequest'

class ReportStore {
  /** Report list */
  @observable type = REPORT_TYPE.PERIODICAL_REPORT
  @observable reportList = []
  @observable reportLists = []
  @observable total = 0
  @observable reportListByQuarterly = []
  @observable totalReportListByQuarterly = 0
  @observable reportDetail = {}

  @observable pageIndex = 0
  @observable pageSize = 10

  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  @action setType = key => {
    this.type = key
  }
  @action getReportList = params => {
    return new Promise((resolve, reject) => {
      ReportRequest.getReportList(params)
        .then(response => {
          this.reportList = response.data.data
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  @action getReportLists = params => {
    return new Promise((resolve, reject) => {
      ReportRequest.getReportlists(params)
        .then(response => {
          this.reportLists = response.data.content
          this.total = response.data.totalPages * response.data.size
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  // api lấy list báo cáo định kỳ theo từng quý
  @action getReportListByQuarterly = params => {
    return new Promise((resolve, reject) => {
      ReportRequest.getReportListByQuarterly(params)
        .then(response => {
          this.reportListByQuarterly = response.data.content
          this.totalReportListByQuarterly = response.data.total
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getReportDetail = code => {
    return new Promise((resolve, reject) => {
      ReportRequest.getReportDetail(code)
        .then(response => {
          this.reportDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createReport = payload => {
    return new Promise((resolve, reject) => {
      ReportRequest.createReport(payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  @action updateReport = (code, payload) => {
    return new Promise((resolve, reject) => {
      ReportRequest.updateReport(code, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  @action updateRiskReport = (code, payload) => {
    return new Promise((resolve, reject) => {
      ReportRequest.updateRiskReport(code, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  @action deleteReport = code => {
    return ReportRequest.deleteReport(code)
  }

  /** Clear store */
  @action clearStore = () => {
    this.reportList.length = 0
  }
}

export default new ReportStore()
